// extracted by mini-css-extract-plugin
module.exports = {"container":"links_container__2n3RN","tptop":"links_tptop__191dn","tpbot":"links_tpbot__1kdbp","nobreak":"links_nobreak__3Piom","space":"links_space__uM8hc"};